import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ImageComponent from '@professocial/professocialFormComponents/FormComponents/ImageComponent'
import { IImageModuleProps } from './Image'

const ProfileImage: React.FC<IImageModuleProps> = (props) => {
  const styles = props.style
  const useStyles = makeStyles((theme: Theme) => ({
    img: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      margin: '0 13px 0 0',
      ...styles,
    },
  }))
  const classes = useStyles()

  return (
    <>
      <ImageComponent className={classes.img} src={props.data} fallback='/src/shared/assets/images/defaultFacebookProfileImage.jpg' />
    </>
  )
}

export default ProfileImage
